import { isBefore, parseISO } from 'date-fns/esm'
import React, { FC } from 'react'
import { useLang } from '../../common/i18n/useLang'
import { Announce } from './Announce'

const FIN = parseISO('2024-09-02T10:00:00+09:00')

export function showMaintenance() {
  return isBefore(new Date(), FIN)
}

export const Maintenance: FC<{ radius?: number; className?: string }> = ({ radius, className }) => {
  const { language } = useLang()
  if (!showMaintenance()) {
    return null
  }
  return (
    <Announce
      radius={radius}
      className={className}
      type={'warning'}
      title={
        language === 'ja' ? 'Pre-admission Support Systemの一時停止について' : 'Notice of temporary unavailability of Pre-admission Support System'
      }
      body={
        language === 'ja' ? (
          <div>
            本システムは、機器メンテナンスに伴い、
            <br />
            2024年8月30日（金）17:00から9月2日（月）10:00まで（日本時間）
            <br />
            サービスを停止いたします。
            <br />
            当該期間はシステムへのログイン及び申請など一切の作業ができませんのでご注意願います。ご理解のほどよろしくお願いいたします
          </div>
        ) : (
          <div>
This system will be unavailable for maintenance from 17:00 Fri 30 Aug 2024 to 10:00 Mon 2 Sep 2024. (Japan time)
            <br />
Please note that during this period you will not be able to log in to the system or perform any operations such as applications. We apologize for any inconvenience caused by this.
          </div>
        )
      }
    />
  )
}
